import { PageOptions } from '../types/AssessmentPageItem';

type AssessmentVideoContainerProps = {
  pageOptions: PageOptions;
};

export function AssessmentVideoContainer({ pageOptions }: AssessmentVideoContainerProps) {
  return (
    <div id="left_container">
      {pageOptions.currentMedia === 'Profile_Setup' && (
        <img
          src="https://res.cloudinary.com/champion-health/image/upload/f_auto,q_auto:best/v1760522175/Screenshot_2025-10-15_at_10.50.07.png"
          alt=""
          className="assessment-image"
        />
      )}
      {pageOptions.currentMedia === 'Behaviour' && (
        <img
          src="https://res.cloudinary.com/champion-health/image/upload/f_auto,q_auto:best/v1760522188/Screenshot_2025-10-15_at_10.54.34.png"
          alt=""
          className="assessment-image"
        />
      )}
      {pageOptions.currentMedia === 'Alcohol' && (
        <img
          src="https://res.cloudinary.com/champion-health/image/upload/f_auto,q_auto:best/v1760522185/Screenshot_2025-10-15_at_10.55.00.png"
          alt=""
          className="assessment-image"
        />
      )}
      {pageOptions.currentMedia === 'Energy' && (
        <img
          src="https://res.cloudinary.com/champion-health/image/upload/f_auto,q_auto:best/v1760522184/Screenshot_2025-10-15_at_10.53.38.png"
          alt=""
          className="assessment-image"
        />
      )}
      {pageOptions.currentMedia === 'Nutrition' && (
        <img
          src="https://res.cloudinary.com/champion-health/image/upload/f_auto,q_auto:best/v1760522181/Screenshot_2025-10-15_at_10.51.37.png"
          alt=""
          className="assessment-image"
        />
      )}
      {pageOptions.currentMedia === 'Hydration' && (
        <img
          src="https://res.cloudinary.com/champion-health/image/upload/f_auto,q_auto:best/v1760522187/Screenshot_2025-10-15_at_10.55.22.png"
          alt=""
          className="assessment-image"
        />
      )}
      {pageOptions.currentMedia === 'Sleep' && (
        <img
          src="https://res.cloudinary.com/champion-health/image/upload/f_auto,q_auto:best,dpr_auto/v1760522186/Screenshot_2025-10-15_at_10.52.47.png"
          alt=""
          className="assessment-image"
        />
      )}
      {pageOptions.currentMedia === 'PhysicalHealth' && (
        <img
          src="https://res.cloudinary.com/champion-health/image/upload/f_auto,q_auto:best/v1760522179/Screenshot_2025-10-15_at_10.53.15.png"
          alt=""
          className="assessment-image"
        />
      )}
      {pageOptions.currentMedia === 'MentalHealth' && (
        <img
          src="https://res.cloudinary.com/champion-health/image/upload/f_auto,q_auto:best/v1760522182/Screenshot_2025-10-15_at_10.54.05.png"
          alt=""
          className="assessment-image"
        />
      )}
      {pageOptions.currentMedia === 'FinancialWellbeing' && (
        <img
          src="https://res.cloudinary.com/champion-health/image/upload/f_auto,q_auto:best/v1760522185/Screenshot_2025-10-15_at_10.52.22.png"
          alt=""
          className="assessment-image"
        />
      )}
      {pageOptions.currentMedia === 'PhysicalActivity' && (
        <img
          src="https://res.cloudinary.com/champion-health/image/upload/f_auto,q_auto:best/v1760522187/Screenshot_2025-10-15_at_10.50.56.png"
          alt=""
          className="assessment-image"
        />
      )}
      {pageOptions.currentMedia !== 'Health' && <div id={pageOptions.currentMedia} />}
    </div>
  );
}
